import { render } from "./DashChartPr.vue?vue&type=template&id=b728a76c&scoped=true&ts=true"
import script from "./DashChartPr.vue?vue&type=script&lang=ts"
export * from "./DashChartPr.vue?vue&type=script&lang=ts"

import "./DashChartPr.vue?vue&type=style&index=0&id=b728a76c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b728a76c"]])

export default __exports__